// help-dialog.component.ts
import { Component, Inject, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { AppStateService } from '../../app-state.service';
import { FormConfigService } from '../forms-config.service';
import { ClinicInformation } from '../clinic.model';

@Component({
  selector: 'app-help-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule
  ],
  template: `
    <h2 mat-dialog-title>Need Help with Your Bill?</h2>
    <mat-dialog-content>
      <p>Our billing specialists are ready to assist you with any questions about your account.</p>
      
      <div class="contact-methods">
        <div class="contact-item">
          <mat-icon>phone</mat-icon>
          <div>
            <strong>Call us</strong>
            <p>{{ clinicInfo.phoneNumber || data.phoneNumber }}</p>
          </div>
        </div>
        
        <div class="contact-item">
          <mat-icon>email</mat-icon>
          <div>
            <strong>Email us</strong>
            <p>{{ clinicInfo.email || data.emailAddress }}</p>
          </div>
        </div>
        
        <div class="contact-item">
          <mat-icon>location_on</mat-icon>
          <div>
            <strong>Address</strong>
            <p>{{ clinicInfo.address || 'Address not available' }}</p>
          </div>
        </div>
        
      </div>
      
      <div class="payment-options">
        <h3>Payment Options</h3>
        <p>We offer flexible payment plans to help manage your healthcare costs. Our billing specialists can discuss options that may be available to you.</p>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button (click)="navigateToClinic()">
        <mat-icon>directions</mat-icon> Get Directions
      </button>
      <button mat-button (click)="callClinic()">
        <mat-icon>call</mat-icon> Call Now
      </button>
      <button mat-button mat-dialog-close>Close</button>
    </mat-dialog-actions>
  `,
  styles: [`
    .contact-methods {
      margin: 1.5rem 0;
    }
    
    .contact-item {
      display: flex;
      align-items: flex-start;
      margin-bottom: 1rem;
    }
    
    .contact-item mat-icon {
      margin-right: 1rem;
      color: #6200ee;
    }
    
    .contact-item p {
      margin: 0.25rem 0 0 0;
    }
    
    .payment-options {
      margin-top: 1.5rem;
      border-top: 1px solid #e0e0e0;
      padding-top: 1.5rem;
    }
    
    .payment-options h3 {
      margin: 0 0 0.75rem 0;
      font-size: 1rem;
    }

    button mat-icon {
      margin-right: 0.5rem;
    }
  `]
})
export class HelpDialogComponent {
  appStateService = inject(AppStateService);
  formConfigService = inject(FormConfigService);
  clientId: string;
  clinicInfo: ClinicInformation = {} as ClinicInformation;

  constructor(
    public dialogRef: MatDialogRef<HelpDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      phoneNumber: string;
      emailAddress: string;
      hours: string;
    }
  ) {
    this.clientId = this.appStateService.getState().clientId || '';
    this.clinicInfo = this.appStateService.getState().clinicInfo || {} as ClinicInformation;
    
    if (!this.clinicInfo.phoneNumber) {
      this.formConfigService.fetchClientInfo(this.clientId).subscribe({
        next: (data: any) => {
          this.clinicInfo = data;
        },
        error: (error: any) => {
        }
      });
    }
  }

  navigateToClinic(): void {
    if (!this.clinicInfo.address) {
      return;
    }
    const address = this.clinicInfo.address;
    const encodedAddress = encodeURIComponent(address);
    window.open(`https://www.google.com/maps/dir/?api=1&destination=${encodedAddress}`, '_blank');
  }

  callClinic() {
    const phoneNumber = this.clinicInfo.phoneNumber || this.data.phoneNumber;
    if (phoneNumber) {
      window.location.href = 'tel:' + phoneNumber;
    } else {
    }
  }
}